import { render } from "./CompanyJobList.vue?vue&type=template&id=1f89856f&scoped=true&ts=true"
import script from "./CompanyJobList.vue?vue&type=script&lang=ts"
export * from "./CompanyJobList.vue?vue&type=script&lang=ts"

import "./CompanyJobList.vue?vue&type=style&index=0&id=1f89856f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f89856f"]])

export default __exports__